import request from '@/utils/request'
// 查询表单组
export async function getFormGroups(param) {
  return request({
    url: 'form/group',
    method: 'get',
    params: param
  })
}

// 表单排序
export async function groupItemsSort(param) {
  return request({
    url: 'form/group/sort',
    method: 'put',
    data: param
  })
}

// 更新表单组
export async function updateGroup(param, method) {
  return request({
    url: 'form/group',
    method: method,
    params: param
  })
}

// 获取表单分组
export function getGroup() {
  return request({
    url: 'form/group/list',
    method: 'get'
  })
}

// 更新表单
export function updateForm(param) {
  return request({
    url: 'form',
    method: 'put',
    params: param
  })
}

export function createForm(param) {
  return request({
    url: 'form',
    method: 'post',
    data: param
  })
}

// 查询表单详情
export function getFormDetail(id) {
  return request({
    url: 'form/detail/' + id,
    method: 'get'
  })
}

// 更新表单详情
export function updateFormDetail(param) {
  return request({
    url: 'form/detail',
    method: 'put',
    data: param
  })
}
// 备份表单
export function backupForm(item) {
    return request({
      url: 'form/backup',
      method: 'get',
      params: { formId: item.id }
    })
}

export default {
  getFormGroups, groupItemsSort, createForm, getFormDetail,
  updateGroup, getGroup, updateForm, updateFormDetail,
  backupForm
}
